var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import API from "@irati/utils/services/API";
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import endpoints from "../endpoints";
import tenantMetadataQuery from "./query/tenantMetadata";
import externalMetadataQuery from "./query/externalTenantMetadata";
import tenantAuditQuery from "./query/tenantAudit";
import tenantMetadataErrorHandler from "./errors/tenantMetadataErrorHandlers";
var TenantMetadataService = /** @class */ (function (_super) {
    __extends(TenantMetadataService, _super);
    function TenantMetadataService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.get = function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return client
                .query(__assign(__assign({}, options), { query: externalMetadataQuery, variables: {
                    tenantId: tenantId
                } }))
                .then(function (_a) {
                var data = _a.data;
                return data.tenantMetadata;
            });
        };
        _this.getFullTenantMetadata = function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return client
                .query(__assign(__assign({}, options), { query: tenantMetadataQuery, variables: {
                    tenantId: tenantId
                } }))
                .then(function (_a) {
                var data = _a.data;
                return data.tenantMetadata;
            });
        };
        _this.getTenantAudit = function (tenantId, action, limit, page, options) {
            if (options === void 0) { options = {}; }
            return client
                .query(__assign(__assign({}, options), { query: tenantAuditQuery, variables: {
                    tenantId: tenantId,
                    action: action,
                    limit: limit,
                    page: page
                } }))
                .then(function (_a) {
                var data = _a.data;
                return data.tenantAudit;
            });
        };
        _this.update = function (data, config) {
            var etag = data.uuid;
            return API.put(endpoints.update(), data, etag, config).then(function (res) { return res.data; });
        };
        return _this;
    }
    return TenantMetadataService;
}(PBService));
var service = new TenantMetadataService({ errorHandlers: [tenantMetadataErrorHandler] });
export var getExternalTenantMetadata = service.get;
export var getFullTenantMetadata = service.getFullTenantMetadata;
export var updateTenantMetadata = service.update;
export var getTenantAudit = service.getTenantAudit;
export default service;
